module.exports = __webpack_public_path__ + "img/image9.e6ef438f.png";